import { __awaiter } from "tslib";
import { DidDocumentUpdateContext } from "../utils/DidDocumentUpdateContext";
class SolanaWalletAdapter {
    constructor(wrappedAdapter, did, wallet, connection) {
        this.wrappedAdapter = wrappedAdapter;
        this.did = did;
        this.wallet = wallet;
        this.connection = connection;
    }
    createTransactionContext() {
        return new DidDocumentUpdateContext(this.wallet, this.connection, this.did);
    }
    init() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.wrappedAdapter.init();
        });
    }
    has(contentId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.wrappedAdapter.has(contentId);
        });
    }
    set(contentId, content, opts) {
        return __awaiter(this, void 0, void 0, function* () {
            let transactionId = null;
            const { results } = yield this.wrappedAdapter.set(contentId, content);
            // If a context is provided, then add the results to the existing context
            if (opts === null || opts === void 0 ? void 0 : opts.context) {
                opts.context.addUpdateResult(results);
            }
            else {
                // otherwise create and commit a context
                const context = this.createTransactionContext();
                context.addUpdateResult(results);
                const updateResult = yield context.commit();
                transactionId = (updateResult === null || updateResult === void 0 ? void 0 : updateResult.transactionId) || null;
            }
            return {
                results,
                transactionId,
            };
        });
    }
    get(contentId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.wrappedAdapter.get(contentId);
        });
    }
}
export default SolanaWalletAdapter;
